<script>
	import { getContext } from 'svelte'
	import { admin } from '../../../library/scripts/PhpHandler.svelte'
	import { get_completed_bookings } from '../AdminModule.svelte'
	import { styles } from '../../../library/scripts/styles'
	import Spinner from '../../../library/ShadersAndSpinners/SpinnerCircle.svelte'
	import Shader from '../../../library/ShadersAndSpinners/Shader.svelte'
	import Alert from '../../../modals/Alert.svelte'

	const globals = getContext('globals')
	const fsXS = globals.fsXS
	const fsS = globals.fsS
	const colorMain = globals.colorMain
	const link = globals.link
	const linkHover = globals.linkHover
	const bg = globals.bgDark
	const inputBgFocus = globals.inputBgFocus

	let completedBookings = get_completed_bookings()
	completedBookings.then((value) => {
		value.forEach((b) => {
			b.total = new Intl.NumberFormat('en-EN', { style: 'currency', currency: b.currency }).format(b.total)
		})
	})

	//send delete
	let showAlert = false

	const close_alert = () => {
		showAlert = false
	}

	let deleteID = null
	const set_delete_booking = async (e) => {
		showAlert = true
		deleteID = e
	}

	const delete_booking = async () => {
		const deleteBooking = await admin({ cmd: 'delete_booking', ID: deleteID })
		if (deleteBooking) {
			completedBookings = deleteBooking
			showAlert = false
		}
	}
</script>

{#await completedBookings}
	<Spinner color={inputBgFocus} size="2vw" info="content loading" fontSize={fsXS} />
{:then booking}
	<div class="container" use:styles={{ bg }}>
		<div class="booked_row underline" use:styles={{ colorMain, fsS }}>
			<div class="cell_center">Room</div>
			<div>Name</div>
			<div>Check-In</div>
			<div>Check-out</div>
			<div>Arrival</div>
			<div>Breakfast</div>
			<div>Total</div>
			<div>Specials</div>
			<div />
		</div>
		<hr />
		{#each booking as booked}
			<div class="booked_row" use:styles={{ colorMain, fsS }}>
				<div class="cell_center">{booked.room}</div>
				<div>{booked.name}</div>
				<div>{booked.checkin}</div>
				<div>{booked.checkout}</div>
				<div>{booked.arrival}</div>
				<div>
					{#if booked.breakfast === '1'}
						included
					{:else}
						not included
					{/if}
				</div>

				<div>{booked.total}</div>
				<div>{booked.specials}</div>
				<div
					class="link"
					use:styles={{ link, linkHover }}
					on:click={() => set_delete_booking(booked.ID)}
					on:keydown={() => set_delete_booking(booked.ID)}
				>
					cancel
				</div>
			</div>
			<hr />
		{/each}
	</div>
{/await}

{#if showAlert}
	<Shader>
		<div slot="content">
			<Alert
				alertMessage="delete booking"
				message="!CAUTION!"
				message2="this action cannot be undone!!"
				on:alertclose={close_alert}
				on:alertok={delete_booking}
			/>
		</div>
	</Shader>
{/if}

<style>
	.container {
		padding: 15px;
		height: auto;
		background-color: var(--bg);
	}
	.booked_row {
		display: grid;
		grid-template-columns:
			clamp(30px, 3.9vw, 60px) clamp(30px, 13vw, 200px) clamp(30px, 7.8vw, 120px) clamp(30px, 7.8vw, 120px)
			clamp(30px, 7.8vw, 120px) clamp(30px, 7.8vw, 120px) clamp(30px, 7.8vw, 120px) 1fr clamp(30px, 3.9vw, 60px);
		column-gap: 10px;
		font-size: var(--fsS);
		color: var(--colorMain);
		margin-bottom: 15px;
	}

	.underline {
		text-decoration: underline;
		margin-bottom: 15px;
	}

	.cell_center {
		display: grid;
		grid-template-columns: 60px;
		justify-items: center;
	}

	.link {
		color: var(--link);
		cursor: pointer;
	}

	.link:hover {
		color: var(--linkHover);
	}
</style>
